export default [
  {
    title: 'Charts',
    icon: { icon: 'mdi-chart-donut' },
    children: [
      { title: 'Apex Chart', to: 'charts-apex-chart', icon: { icon: 'mdi-chart-bell-curve' } },
      { title: 'Chartjs', to: 'charts-chartjs', icon: { icon: 'mdi-chart-bell-curve-cumulative' } },
    ],
  },
]
